var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { float: "left" } },
        [
          _vm.filtrosAplicados.length > 0
            ? _c(
                "vs-chip",
                {
                  staticClass: "accionable",
                  attrs: { color: _vm.colores.navbar },
                  nativeOn: {
                    click: function($event) {
                      return _vm.aplicarFiltros()
                    }
                  }
                },
                [
                  _c("vs-avatar", {
                    attrs: {
                      icon: "search",
                      color: "primary",
                      badge: _vm.filtrosAplicados.length
                    }
                  }),
                  _c("strong", [_vm._v("Aplicar filtros")])
                ],
                1
              )
            : _vm._e(),
          _vm.filtrosAplicados.length === 0
            ? _c(
                "vs-chip",
                { attrs: { color: "gray" } },
                [
                  _c("vs-avatar", { attrs: { icon: "search", color: "#ccc" } }),
                  _c("strong", [_vm._v("No hay filtros aplicados")])
                ],
                1
              )
            : _vm._e(),
          _vm.hasQueryFilters
            ? _c(
                "vs-chip",
                {
                  staticStyle: { cursor: "context-menu" },
                  attrs: { color: _vm.colores.navbar },
                  nativeOn: {
                    click: function($event) {
                      return _vm.clearQueryFilters()
                    }
                  }
                },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "link", color: "primary" }
                  }),
                  _c("strong", [_vm._v("Borrar filtros de enlace")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { float: "right" } },
        [
          _c(
            "vs-dropdown",
            { attrs: { "vs-trigger-click": "", "data-cy": "add-filter" } },
            [
              _c(
                "vs-chip",
                { attrs: { color: "primary" } },
                [
                  _c("vs-avatar", { attrs: { icon: "add", color: "primary" } }),
                  _vm._v(" Agregar filtro ")
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                {
                  staticClass: "scroll-options shadow",
                  attrs: { "data-cy": "list" }
                },
                _vm._l(_vm.filtrosDisponibles, function(filtro, index) {
                  return _c(
                    "vs-dropdown-item",
                    {
                      key: "filtro-" + index,
                      staticStyle: { width: "200px" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.agregarFiltro(filtro, true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            typeof filtro == "undefined" ? "" : filtro.nombre
                          ) +
                          " "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", {
        staticStyle: {
          clear: "both",
          "border-bottom": "solid 1px #ccc",
          "margin-bottom": "10px"
        }
      }),
      _vm._l(_vm.filtrosAplicados, function(filtro, index) {
        return _c(
          "vs-chip",
          {
            key: "filtro-aplicado-" + index,
            staticStyle: { cursor: "context-menu" },
            attrs: { color: _vm.colores.navbar },
            nativeOn: {
              click: function($event) {
                return _vm.ventanaModificarFiltro(filtro)
              }
            }
          },
          [
            _vm.esEliminable[filtro.campo]
              ? _c("vs-avatar", {
                  attrs: { icon: "clear", color: "primary" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.eliminarFiltro(filtro)
                    }
                  }
                })
              : _vm._e(),
            _c("span"),
            _c(
              "vs-tooltip",
              { attrs: { text: "Modificar filtro " + filtro.nombre } },
              [
                _c("strong", [
                  _vm._v(
                    _vm._s(typeof filtro == "undefined" ? "" : filtro.nombre) +
                      ": "
                  )
                ]),
                _c("span", { staticClass: "pl-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        typeof filtro == "undefined"
                          ? ""
                          : filtro.valorFormateado || ""
                      ) +
                      " "
                  )
                ])
              ]
            )
          ],
          1
        )
      }),
      _c(
        "vs-modal",
        {
          ref: "configFiltro",
          attrs: { "dismiss-on": "close-button esc" },
          on: { close: _vm.verificarFiltrosAlCerrar }
        },
        [
          _c("div", {
            staticClass: "titulo-modal",
            attrs: { slot: "header" },
            domProps: { innerHTML: _vm._s(_vm.tituloConfiguracion) },
            slot: "header"
          }),
          _vm.filtroActual.tipo == "multi"
            ? _c(
                "div",
                [
                  _vm.filtroActual.valor.length == 1
                    ? _c("div", { staticClass: "alerta" }, [
                        _vm._v(
                          " Debe seleccionar como mínimo 1 de las opciones. Seleccione otra opción antes de desmarcar la actual si es que desea cambiarla. "
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "vs-checkbox",
                    {
                      staticClass: "modal-opcion",
                      nativeOn: {
                        change: function($event) {
                          return _vm.modificarFiltro(_vm.filtroActual)
                        }
                      },
                      model: {
                        value: _vm.seleccionarTodos,
                        callback: function($$v) {
                          _vm.seleccionarTodos = $$v
                        },
                        expression: "seleccionarTodos"
                      }
                    },
                    [_vm._v(" Seleccionar Todos ")]
                  ),
                  _c("hr"),
                  _c("br"),
                  _vm._l(_vm.filtroActual.opciones, function(opcion) {
                    return _c(
                      "div",
                      { key: opcion.nombre, staticClass: "modal-opcion" },
                      [
                        _c(
                          "vs-checkbox",
                          {
                            attrs: {
                              "vs-value": opcion.valor,
                              disabled:
                                _vm.filtroActual.valor.length === 1 &&
                                _vm.filtroActual.valor.includes(opcion.valor)
                            },
                            nativeOn: {
                              change: function($event) {
                                return _vm.modificarFiltro(_vm.filtroActual)
                              }
                            },
                            model: {
                              value: _vm.filtroActual.valor,
                              callback: function($$v) {
                                _vm.$set(_vm.filtroActual, "valor", $$v)
                              },
                              expression: "filtroActual.valor"
                            }
                          },
                          [_vm._v(" " + _vm._s(opcion.nombre) + " ")]
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm.filtroActual.tipo == "numero"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("vue-tags-input", {
                      attrs: {
                        tags: _vm.tags,
                        placeholder: "Agregar",
                        separators: [","],
                        validation: [
                          {
                            classes: "es-numero",
                            rule: /^\d+$/,
                            disableAdd: true
                          }
                        ]
                      },
                      on: {
                        "tags-changed": function(newTags) {
                          return (_vm.tags = newTags)
                        }
                      },
                      model: {
                        value: _vm.tag,
                        callback: function($$v) {
                          _vm.tag = $$v
                        },
                        expression: "tag"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "rut"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("vue-tags-input", {
                      attrs: {
                        tags: _vm.tags,
                        placeholder: "Agregar",
                        separators: [","],
                        validation: [
                          {
                            classes: "es-rut",
                            rule: /^\d{1,2}\d{3}\d{3}[-][0-9kK]{1}$/,
                            disableAdd: true
                          }
                        ]
                      },
                      on: {
                        "tags-changed": function(newTags) {
                          return (_vm.tags = newTags)
                        }
                      },
                      model: {
                        value: _vm.tag,
                        callback: function($$v) {
                          _vm.tag = $$v
                        },
                        expression: "tag"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "texto"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("vue-tags-input", {
                      attrs: {
                        tags: _vm.tags,
                        placeholder: "Agregar",
                        separators: [","]
                      },
                      on: {
                        "tags-changed": function(newTags) {
                          return (_vm.tags = newTags)
                        }
                      },
                      model: {
                        value: _vm.tag,
                        callback: function($$v) {
                          _vm.tag = $$v
                        },
                        expression: "tag"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "solicitanteCorreo" ||
          _vm.filtroActual.tipo == "correo"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "select-label": "Presiona enter para seleccionar",
                        "selected-label": "Presiona enter para remover",
                        "deselect-label": "Presiona enter para remover",
                        placeholder: "Seleccione los usuarios",
                        label: "nombre",
                        "track-by": "valor",
                        options: _vm.filtroActual.opciones,
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        "preserve-search": true,
                        "preselect-first": false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(values.length) +
                                            " usuarios seleccionados"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        201108783
                      ),
                      model: {
                        value: _vm.filterCreators,
                        callback: function($$v) {
                          _vm.filterCreators = $$v
                        },
                        expression: "filterCreators"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "destinoCopiaIds"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "select-label": "Presiona enter para seleccionar",
                        "selected-label": "Presiona enter para remover",
                        "deselect-label": "Presiona enter para remover",
                        placeholder: "Seleccione los usuarios",
                        label: "nombre",
                        "track-by": "valor",
                        options: _vm.filtroActual.opciones,
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        "preserve-search": true,
                        "preselect-first": false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(values.length) +
                                            " usuarios seleccionados"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        201108783
                      ),
                      model: {
                        value: _vm.filterCopies,
                        callback: function($$v) {
                          _vm.filterCopies = $$v
                        },
                        expression: "filterCopies"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "destinoUsuarios" ||
          _vm.filtroActual.tipo == "usuarioIds"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "select-label": "Presiona enter para seleccionar",
                        "selected-label": "Presiona enter para remover",
                        "deselect-label": "Presiona enter para remover",
                        placeholder: "Seleccione los usuarios",
                        label: "nombre",
                        "track-by": "valor",
                        options: _vm.filtroActual.opciones,
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        "preserve-search": true,
                        "preselect-first": false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(values.length) +
                                            " usuarios seleccionados"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        201108783
                      ),
                      model: {
                        value: _vm.filterUsers,
                        callback: function($$v) {
                          _vm.filterUsers = $$v
                        },
                        expression: "filterUsers"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "tipoDocumento"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "select-label": "Presiona enter para seleccionar",
                        "selected-label": "Presiona enter para remover",
                        "deselect-label": "Presiona enter para remover",
                        placeholder: "Seleccione los tipos",
                        label: "nombre",
                        "track-by": "valor",
                        options: _vm.filtroActual.opciones,
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        "preserve-search": true,
                        "preselect-first": false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(values.length) +
                                            " tipos seleccionados"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2728227659
                      ),
                      model: {
                        value: _vm.filterDocuments,
                        callback: function($$v) {
                          _vm.filterDocuments = $$v
                        },
                        expression: "filterDocuments"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "tipoInstitucion"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "select-label": "Presiona enter para seleccionar",
                        "selected-label": "Presiona enter para remover",
                        "deselect-label": "Presiona enter para remover",
                        placeholder: "Seleccione los tipos",
                        label: "nombre",
                        "track-by": "valor",
                        options: _vm.filtroActual.opciones,
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        "preserve-search": true,
                        "preselect-first": false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(values.length) +
                                            " tipos seleccionados"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2728227659
                      ),
                      model: {
                        value: _vm.filterInstitutions,
                        callback: function($$v) {
                          _vm.filterInstitutions = $$v
                        },
                        expression: "filterInstitutions"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo == "destinoGrupos"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "select-label": "Presiona enter para seleccionar",
                        "selected-label": "Presiona enter para remover",
                        "deselect-label": "Presiona enter para remover",
                        placeholder: "Seleccione los grupos",
                        label: "nombre",
                        "track-by": "valor",
                        options: _vm.filtroActual.opciones,
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        "preserve-search": true,
                        "preselect-first": false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(values.length) +
                                            " grupos seleccionados"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2650963030
                      ),
                      model: {
                        value: _vm.filterGroups,
                        callback: function($$v) {
                          _vm.filterGroups = $$v
                        },
                        expression: "filterGroups"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo === "destinoCorreos"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "texto-normal" },
                  [
                    _c("vue-tags-input", {
                      attrs: {
                        tags: _vm.filterEmails,
                        placeholder: "Agregar",
                        separators: [","]
                      },
                      on: {
                        "tags-changed": function(newTags) {
                          return (_vm.filterEmails = newTags)
                        }
                      },
                      model: {
                        value: _vm.emails,
                        callback: function($$v) {
                          _vm.emails = $$v
                        },
                        expression: "emails"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.filtroActual.tipo === "rangoFecha"
            ? _c("div", [
                _c("div", { staticClass: "swtich-tipo-rango" }, [
                  _c("div", { staticClass: "rango-parte" }, [
                    _vm._v("Rango Simple")
                  ]),
                  _c(
                    "div",
                    { staticClass: "rango-parte rango-switch" },
                    [
                      _c("vs-switch", {
                        model: {
                          value: _vm.tipoRangoFechaAvanzado,
                          callback: function($$v) {
                            _vm.tipoRangoFechaAvanzado = $$v
                          },
                          expression: "tipoRangoFechaAvanzado"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "rango-parte" }, [
                    _vm._v("Rango Avanzado")
                  ])
                ]),
                _c("br"),
                _c("hr"),
                _c("br"),
                !_vm.tipoRangoFechaAvanzado
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "center" },
                        [
                          _vm._l(_vm.periodos, function(periodo, index) {
                            return [
                              _c(
                                "vs-button",
                                {
                                  key: "periodo-" + index,
                                  staticClass: "w-full mb-1",
                                  attrs: {
                                    disabled:
                                      periodo.valor === _vm.filtroActual.valor,
                                    size: "medium",
                                    color: "primary",
                                    type: "filled"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.seleccionarRango(
                                        _vm.filtroActual,
                                        periodo.valor
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        periodo.nombre.charAt(0).toUpperCase() +
                                          periodo.nombre.slice(1)
                                      ) +
                                      " "
                                  ),
                                  _c("br"),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "80%" } },
                                    [
                                      _vm._v(
                                        " (desde el " +
                                          _vm._s(
                                            _vm.formatoTipoRango(
                                              periodo.valor,
                                              true
                                            )
                                          ) +
                                          " hasta hoy) "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  : _vm._e(),
                _vm.tipoRangoFechaAvanzado
                  ? _c(
                      "div",
                      [
                        _vm._v(" entre el "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "fecha",
                            phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                            "value-zone": "local",
                            format: "yyyy-MM-dd",
                            "data-cy": "start-time"
                          },
                          model: {
                            value: _vm.rangoAvanzado.desde,
                            callback: function($$v) {
                              _vm.$set(_vm.rangoAvanzado, "desde", $$v)
                            },
                            expression: "rangoAvanzado.desde"
                          }
                        }),
                        _vm._v(" y el "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "fecha",
                            phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                            "value-zone": "local",
                            format: "yyyy-MM-dd",
                            "data-cy": "end-time"
                          },
                          model: {
                            value: _vm.rangoAvanzado.hasta,
                            callback: function($$v) {
                              _vm.$set(_vm.rangoAvanzado, "hasta", $$v)
                            },
                            expression: "rangoAvanzado.hasta"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "text-center mt-2" },
            [
              _c(
                "vs-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.verificarFiltrosAlCerrar }
                },
                [_vm._v(" Confirmar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }